<template>
  <v-sheet
    class="px-6 npo-card"
    color="white"
    tile
    :height="expanded ? '' : 'auto'"
    @click="$emit('go-to-npo', npo.npo_id)"
    :class="{ 'npo-selected': selected }"
    :style="styleObject"
  >
    <v-img
      v-if="npo.logo && campaign.show_npo_logo"
      contain
      :aspect-ratio="1 / 1"
      :src="
        'data:image/png;base64,' + npo.logo ||
        'https://via.placeholder.com/640x200/DFDFDF?Text=Npo+image'
      "
      class="mx-auto"
      height="50"
    ></v-img>
    <v-list-item>
      <v-list-item-content class="py-2">
        <v-list-item-subtitle class="text-primary text-center secondary">
        </v-list-item-subtitle>
        <v-list-item-title class="text-center text-h6 secondary py-4">
          {{ npo.name }}
        </v-list-item-title>
        <v-list-item-subtitle class="text-primary text-center secondary py-2">
          {{ npo.address | capitalize }}  {{npo.zip_code}} {{npo.city}}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text
      class="text-center"
      style="background-color: white"
      v-if="campaign.show_npo_description"
    >
      {{ npo.description }}
    </v-card-text>
  </v-sheet>
</template>

<script>
export default {
  props: {
    npo: {
      type: Object
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      styleObject: {
        transform: 'translate(0px, 0px)'
      },
      selected: false,
      leadId: null,
      campaignId: null,
      campaign: null
    }
  },

  created () {
    if (JSON.parse(sessionStorage.getItem('campaign'))) {
      const campaign = JSON.parse(sessionStorage.getItem('campaign'))
      this.campaignId = campaign.campaign_id
      this.campaign = campaign
    } else {
      this.campaignId = sessionStorage.getItem('campaign_id')
      this.leadId = sessionStorage.getItem('lead_id')
    }
  }
}
</script>
<style scoped>
.v-navigation-drawer {
  transition: none !important;
}

.v-content {
  background-color: #fff;
}

.npo-card {
  overflow: hidden;
  transition: all 0.5s cubic-bezier(0.56, 0, 0.56, 1.29);
}
.npo-selected {
  z-index: 100;
  border-radius: 0;
  border: 0;
  width: 100vw;
  height: 100vh !important;
}
.npo-name {
  font-size: 2rem;
}
</style>
